import { gql } from '@apollo/client';

export const SHOP_PRODUCTS_QUERY = gql`
  query ShopProducts {
    shop {
      name
      primaryDomain {
        url
      }
    }
    products(first: 10) {
      edges {
        node {
          id
          title
          images(first: 1) {
            edges {
              node {
                id
                altText
                originalSrc
              }
            }
          }
          priceRange {
            minVariantPrice {
              amount
              currencyCode
            }
            maxVariantPrice {
              amount
              currencyCode
            }
          }
          onlineStoreUrl
        }
      }
    }
  }
`;

export const getProductShopify = gql`
  query getProductById($id: ID!) {
    product(id: $id) {
      title
      priceRange {
        minVariantPrice {
          amount
          currencyCode
        }
        maxVariantPrice {
          amount
          currencyCode
        }
      }
      images(first: 1) {
        edges {
          node {
            id
            altText
            originalSrc
          }
        }
      }
      featuredImage {
        src
      }
      description
      onlineStoreUrl
      handle
    }
  }
`;
